import React, { useEffect } from 'react';
import { ILayout } from '../backend';
import { IFields, IPageFields, Steps } from '../types/state';
import './BasicInfo.scss';
import FormPage from './FormPage';
import SubComponents from './subcomponents/SubComponents';
import { useLocalize } from '../context/localize';

interface IProps {
  layout?: ILayout;
  onValueChange: (field: string, value: any, step: Steps, valid?: boolean) => void;
  onSubmit: () => void;
  setLanguage: (language: string) => void;
  languages: string[] | null;
  basicInformation: IPageFields;
  valid: boolean;
  errorMessage?: string;
}

function BasicInfo({
  layout,
  basicInformation,
  onValueChange,
  valid,
  onSubmit,
  errorMessage,
  setLanguage,
  languages,
}: IProps) {
  const localize = useLocalize();

  useEffect(() => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }, []);

  return (
    <FormPage
      layout={layout}
      valid={valid}
      errorMessage={errorMessage}
      onSubmit={onSubmit}
      setLanguage={setLanguage}
      languages={languages}
    >
      <h3 className='form-header'>{localize('basicInfoTitle')}</h3>
      <p className='form-title'>
        {localize('basicInfoSubtitle')}
      </p>
      <p className='required-info'>{localize('basicInfoRequired')}</p>
      <div className='basic-info-container'>
        {basicInformation.fields
          ?.filter((f: IFields) => f.visible)
          .map((f: IFields) => {
            const value = f.value;
            return (
              <SubComponents
                key={f.id}
                value={value}
                field={f}
                step='basicInformation'
                onValueChange={onValueChange}
              />
            );
          })}
      </div>
    </FormPage>
  );
}

export default BasicInfo;
